import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import { Card, Col, Container, Form, InputGroup, Row } from 'react-bootstrap';
import "bootstrap/dist/css/bootstrap.min.css";
import { useCookies } from "react-cookie";
import "../general.css";
import CrossWord from './cossword';

const Legend = ({ en }) => {
    const [cookies, setCookie, removeCookie] = useCookies();
    const [spAns, setSpAns] = useState(["", "", "", "", ""]);
    useEffect(() => {
        if (cookies.spAns) {
            setSpAns(cookies.spAns);
        }
    }, []
    );

    // フォーム内容が更新されたとき
    const handlerChange = (e, n) => {
        let ans = spAns;
        ans[n] = e.target.value;
        setSpAns(ans);
        setCookie("spAns", ans);
    };

    return (
        <>
            {en ? "Saudi Arabia has this legend…" : "サウジアラビアにはこのような伝説がある。"}
            <Card className='my-2'>
                <Card.Header>{en ? "Prophet Abraham's Biography" : "『預言者伝』"}</Card.Header>
                <Card.Body className='background-image-position' style={{ backgroundImage: 'url("/img/paper2.jpg")' }}>
                    {en ? (
                        <>
                            When Mrs. Hajar and her son went to the hot and dry land supported by Abraham's divine command, they lost their نوميميزو.
                            <br />They went somewhere to get their ميزو.
                            <br /><br />Unfortunately, they could not find it.
                            <br />They were disappointed, but suddenly,  ميزو was spurting out.
                            <br />It is dangerous, so Mrs. Hajar said to ميزو, “زمزم”.
                            <br />Gradually, ميزو had weakened the momentum and it becomes a beautiful إيزومي.
                        </>
                    ) : (<>
                        <p>灼熱し乾燥した地で نوميميزو が尽きてしまったハージャルは、 ميزو を求めて放浪していた。</p>
                        <p>もうダメかと思われたその時、神の奇跡によって ميزو  がほとばしり出てきた。</p>
                        <p>そして、 ميزو に向かって「زمزم 」と言葉を発すると、 ميزو は勢いを弱め إيزومي となった。</p>
                    </>
                    )}
                </Card.Body>
            </Card>
            {en ? (
                <>
                    If your life is threatened, please act according to this legend.
                    <br />Searching سويجن and saying زمزم there, you can survive.
                    <br />When you finish deciphering Arabic, God should lead you to the place where سويجن is.
                </>
            ) : (
                <>
                    命の危機に直面したら、この伝説に基づいて行動するべし。
                    <br />
                    教室の中から سويجن を探し出し「زمزم 」と言葉を発すれば、命は救われる。
                    <br />
                    アラビア語をすべて解読すれば、سويجن の場所を神が導いてくれるだろう。
                </>
            )}
        </>
    )
}

export default Legend;
